import { render } from "./CompleteTextCalltype.vue?vue&type=template&id=7cad58a1&scoped=true&ts=true"
import script from "./CompleteTextCalltype.vue?vue&type=script&lang=ts"
export * from "./CompleteTextCalltype.vue?vue&type=script&lang=ts"

import "./CompleteTextCalltype.vue?vue&type=style&index=0&id=7cad58a1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cad58a1"]])

export default __exports__